import { gql } from "apollo-boost";

const SYNC_INVENTORY_VENDOR = gql`
  mutation syncInventoryVendor {
    syncInventoryVendor {
      status
      data
      error
    }
  }
`;

const SYNC_PRODUCT_TAG = gql`
  mutation syncProductSellerTag {
    syncProductSellerTag {
      status
      data
      error
    }
  }
`;

const SYNC_PRODUCT_TYPE = gql`
  mutation syncProductSellertype {
    syncProductSellerType {
      status
      data
      error
    }
  }
`;

const DISCONNECT_SHOP = gql`
  mutation disconnectShop($input: DisconnectShop) {
    disconnectShop(input: $input) {
      status
      data
      error
    }
  }
`;

const IS_STORE_CONNECTED = gql`
  mutation isStoreConnected($input: IsStoreConnected!) {
    isStoreConnected(input: $input) {
      status
      data {
        associated
        supplier
      }
      error
    }
  }
`;
const SYNC_WOOCOMMERCE_VENDOR_PRODUCT = gql`
  mutation syncWooCommerceVendorProduct {
    syncWooCommerceVendorProduct {
      status
      data
      error
    }
  }
`;
export {
  DISCONNECT_SHOP,
  IS_STORE_CONNECTED,
  SYNC_INVENTORY_VENDOR,
  SYNC_PRODUCT_TAG,
  SYNC_PRODUCT_TYPE,
  SYNC_WOOCOMMERCE_VENDOR_PRODUCT,
};
